/* eslint-disable */
import * as util from "@/api/monitoring";

const state = {
    formParamListScrapingSt: {
        columnFilters: {
            start_date: "",
            end_date: "",
            product_id: "",
            brand_id: "",
            product_price_start: "",
            product_price_end: "",
        },
        page: 1,
        perPage: 20,
        more_search: false
    },
    isShowForm: false,
    isShowFormAdd: false,
    isShowFormImport: false,
    isShowFormImportHtml: false,
    isShowFormEdit: false,
    isShowFormEditId: '',
    isShowFormReport: false,
    formParamReport: {
        date: "",
        brand_id: "",
    },
    actFormEditSt: {
        id: "",
        mp_id: "",
        brand_id: "",
        product_id: "",
        store_name: "",
        store_link: "",
        product_name: "",
        product_url: "",
        product_price_start: "",
        product_price_end: "",
        product_image1: "",
        scraping_file_screenshot: "",
        status_value: ""
    },
    formParamScrapeSt: {
        id: "",
        title: "",
        mp_product_master_id: "",
        keywords_id: [],
        min_price: 0,
        max_price: 0,
        sort_by: "price",
        order_by: "desc",
        mp_id: [],
        sending_options: 1,
        is_publish: 1,
        sending_schedule: "",
        is_recurring: 0,
        max_pagination_status: false,
        recurring_form: {
            recurrence: "",
            recurrence_time: "00:01",
            recurrence_every: "",
            recurrence_annually_month: "",
            recurrence_end: "never",
            recurrence_end_date: ""
        },
    },
    formParamSt: {
        columnFilters: {
            start_date: "",
            end_date: "",
            product_id: "",
            brand_id: "",
            mp_id: "",
            status_value: "",
            sr_detail_id: "",
            rating: "",
            is_store_name: "",
            store_name: "",
            product_name: "",
            product_url: "",
            product_price_start: "",
            product_price_end: "",
        },
        page: 1,
        perPage: 20,
        more_search: false,
        mpIds: [],
        mpIdsExclude: []
    },
    formParamStB: {
        columnFilters: {
            start_date: "",
            end_date: "",
            product_id: "",
            brand_id: "",
            mp_id: "",
            status_value: "",
            sr_detail_id: "",
            rating: "",
            is_store_name: "",
            store_name: "",
            product_name: "",
            product_url: "",
            product_price_start: "",
            product_price_end: "",
            is_bookmark: 1,
        },
        page: 1,
        perPage: 20,
        more_search: false,
        mpIds: []
    },
    formParamStD: {
        columnFilters: {
            start_date: "",
            end_date: "",
            product_id: "",
            brand_id: "",
            mp_id: "",
            status_value: "",
            sr_detail_id: "",
            rating: "",
            is_store_name: "",
            store_name: "",
            product_name: "",
            product_url: "",
            product_price_start: "",
            product_price_end: "",
            is_bookmark: 1,
        },
        page: 1,
        perPage: 20,
        more_search: false,
        mpIds: []
    },
    formParamListLogSt: {
        columnFilters: {
            start_date: "",
            end_date: "",
            product_id: "",
            brand_id: "",
            mp_id: "",
            is_product_found: "",
            keywords_name: "",
        },
        page: 1,
        perPage: 20,
        more_search: false
    },
};

const mutations = {
    SET_formParamListScrapingSt: (state, value) => {
        state.formParamListScrapingSt = value
    },
    SET_formParamScrapeSt: (state, value) => {
        state.formParamScrapeSt = value
    },
    SET_formParamListLogSt: (state, value) => {
        state.formParamListLogSt = value
    },
    SET_formParamSt: (state, value) => {
        state.formParamSt = value
    },
    SET_formParamStB: (state, value) => {
        state.formParamStB = value
    },
    SET_formParamStD: (state, value) => {
        state.formParamStD = value
    },
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
    SET_isShowFormAdd: (state, value) => {
        state.isShowFormAdd = value
    },
    SET_isShowFormImport: (state, value) => {
        state.isShowFormImport = value
    },
    SET_isShowFormImportHtml: (state, value) => {
        state.isShowFormImportHtml = value
    },
    SET_isShowFormEdit: (state, value) => {
        state.isShowFormEdit = value
    },
    SET_isShowFormEditId: (state, value) => {
        state.isShowFormEditId = value
    },
    SET_actFormEditSt: (state, value) => {
        state.actFormEditSt = value
    },
    SET_isShowFormReport: (state, value) => {
        state.isShowFormReport = value
    },
    SET_formParamReport: (state, value) => {
        state.formParamReport = value
    },
};

const actions = {
    getDetailEditByScheduleId({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.getDetailEditByScheduleId(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    scrapingActionStored({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.scrapingActionStored(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMarketplaceByScheduleId({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.getMarketplaceByScheduleId(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getKeywordsByScheduleId({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.getKeywordsByScheduleId(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listScraping({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listScraping(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    retryScrapingRawDetail({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.retryScrapingRawDetail(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    scrapingDetailProduct({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.scrapingDetailProduct(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listLinkExcel({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listLinkExcel(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listLinkExcelMP({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listLinkExcelMP(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listLinkPDFMP({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listLinkPDFMP(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    agentListLinkExcel({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.agentListLinkExcel(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    agentListLinkExcelMP({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.agentListLinkExcelMP(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    agentListLinkPDFMP({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.agentListLinkPDFMP(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    monitoringActionStore({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.monitoringActionStore(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    scrapePreparing({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.scrapePreparing(params).then(response => {
                commit("SET_formParamScrapeSt", {
                    id: "",
                    title: "",
                    mp_product_master_id: "",
                    keywords_id: [],
                    min_price: 0,
                    max_price: 0,
                    sort_by: "price",
                    order_by: "desc",
                    mp_id: [],
                    sending_options: 1,
                    is_publish: 1,
                    sending_schedule: "",
                    is_recurring: 0,
                    recurring_form: {
                        recurrence: "",
                        recurrence_time: "00:01",
                        recurrence_every: "",
                        recurrence_annually_month: "",
                        recurrence_end: "never",
                        recurrence_end_date: ""
                    },
                });

                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamListScrapingSt({ commit }, data) {
        commit("SET_formParamListScrapingSt", data);
    },
    actFormParamScrapeSt({ commit }, data) {
        commit("SET_formParamScrapeSt", data);
    },
    detailKeywords({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.detailKeywords(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    addKeywords({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.addKeywords(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listKeywords({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listKeywords(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMonitoringSortByList() {
        return new Promise((resolve, reject) => {
            util.getMonitoringSortByList().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMarketplaceList() {
        return new Promise((resolve, reject) => {
            util.getMarketplaceList().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMonitoringListAction() {
        return new Promise((resolve, reject) => {
            util.getMonitoringListAction().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getMonitoringListStatus() {
        return new Promise((resolve, reject) => {
            util.getMonitoringListStatus().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamListLogSt({ commit }, data) {
        commit("SET_formParamListLogSt", data);
    },
    listLog({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listLog(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listLink({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listLink(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    agentListLink({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.agentListLink(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamSt({ commit }, data) {
        commit("SET_formParamSt", data);
    },
    actFormParamStB({ commit }, data) {
        commit("SET_formParamStB", data);
    },
    actFormParamStD({ commit }, data) {
        commit("SET_formParamStD", data);
    },
    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
    setIsShowFormAdd({ commit }, data) {
        commit("SET_isShowFormAdd", data);
    },
    setIsShowFormImport({ commit }, data) {
        commit("SET_isShowFormImport", data);
    },
    setIsShowFormImportHtml({ commit }, data) {
        commit("SET_isShowFormImportHtml", data);
    },
    setIsShowFormReport({ commit }, data) {
        commit("SET_isShowFormReport", data);
    },
    actFormParamReport({ commit }, data) {
        commit("SET_formParamReport", data);
    },
    upload_attachment({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.upload_attachment(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    validationManualAdd({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.validationManualAdd(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storedManualAdd({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storedManualAdd(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setIsShowFormEdit({ commit }, data) {
        commit("SET_isShowFormEdit", data);
    },
    setIsShowFormEditId({ commit }, data) {
        commit("SET_isShowFormEditId", data);
    },
    setActFormEditSt({ commit }, data) {
        commit("SET_actFormEditSt", data);
    },
    validationManualUpdate({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.validationManualUpdate(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storedManualUpdate({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storedManualUpdate(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    previewImport({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.previewImport(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    validationImport({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.validationImport(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storedImport({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storedImport(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storedImportHtml({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storedImportHtml(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    parsingShopeeSearchItemProduct({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.parsingShopeeSearchItemProduct(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    parsingTokopediaSearchItemProduct({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.parsingTokopediaSearchItemProduct(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    parsingLazadaSearchItemProduct({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.parsingLazadaSearchItemProduct(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    parsingBukalapakSearchItemProduct({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.parsingBukalapakSearchItemProduct(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    bookmark({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.bookmark(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    unbookmark({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.unbookmark(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    reportSummary({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.reportSummary(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listDuplicate({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listDuplicate(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    duplicate({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.duplicate(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    duplicateRestore({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.duplicateRestore(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    duplicateDelete({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.duplicateDelete(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/monitoring.js